import { Component, OnInit, Input } from '@angular/core';
import { NewInspectionService } from '../../inpsection.service';
import { PhotoModelComingFrom,
  PreInspectionChecklistVM,
  CheckListImagesVM} from '../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { GETViewPhotoComponent } from '../../../shared/view-photo/view-photo.component';
import { AppService } from '../../../../../app.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-pre-inspection-checklist',
  templateUrl: './pre-inspection-checklist.component.html',
  styleUrls: ['./pre-inspection-checklist.component.scss']
})
export class PreInspectionChecklistComponent implements OnInit {

PreChecklistAnswers:PreInspectionChecklistVM[]=[];
NewAnswer:boolean
  @Input()inspectionID :number;
  constructor(
    private route: ActivatedRoute,
    private _inspectionService: NewInspectionService,
    private _sanitizer: DomSanitizer, private _appService: AppService,
    private _toaster: NotificationsService,
    private _dialog: MatDialog,
  ) { }

  ngOnInit() {
    console.log("this.inspectionID__", this.inspectionID)
if(this.inspectionID>0){
  this.LoadPreInspectionChecklistData();
}

  }

  LoadPreInspectionChecklistData(){
      this._inspectionService.GetPreInspectionChecklistInfo(this.inspectionID).subscribe(res=>{
        this.PreChecklistAnswers=res;
        console.log("PreChecklistAnswers", this.PreChecklistAnswers)
      })
  }

  commentChanged(comment, PreChecklistAnswers: PreInspectionChecklistVM) {
    console.log(comment);
    //this.LoadPreInspectionChecklistData();
  }

  ChangeCheckListAnswer(AnswerId:number,event:any){
    //this.NewAnswer = event.value;
    if (AnswerId > 0) {
      this.NewAnswer = event.value==-1?null:event.value==1?true:false;
      this._inspectionService.ChangePreCheckListAnswer(AnswerId,this.NewAnswer).subscribe(r => {
          if (r.m_Item1) {
              this._toaster.success( 'Update Answer Sucessfully');
          } else {
              this._toaster.error( 'Failed to update the Answer');
          }
      });
  }
  }
  photoRecevied(image, preChecklist: PreInspectionChecklistVM,imageID:number) {
   // const newPhoto = new ObservationImagesViewModel(image);
    var imageview = new CheckListImagesVM();
    imageview.Image=image.Image;
    imageview.AnswerId = preChecklist.ChecklistAnswerId;
    imageview.Id = image.Id;
    if (preChecklist.Images !== undefined) {
      preChecklist.Images.push(imageview);
    }    else {
      preChecklist.Images = [];
      preChecklist.Images.push(imageview);
    }
   
  }
  viewObservationImage(img: CheckListImagesVM, preChecklist: PreInspectionChecklistVM) {
    console.log("Image_selected,", img)
    const passingData =  {
      comingFrom: PhotoModelComingFrom.PreCheckListQuestionImages,    
      imageChecklist: img,
      preChecklist:preChecklist
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe(changes => {
      if (changes) {
        this.LoadPreInspectionChecklistData();
      }
    });
  }

  getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }
  }

}
